import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { loadType } from "../../../shared/load-type/load-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { Chip } from "primeng/chip";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-load-type-select",
  templateUrl: "./load-type-select.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Chip, FormsModule],
})
export class LoadTypeSelectComponent implements OnInit {
  public readonly loadTypeChange = output<string | null>();
  @Input() public loadType: string | null = null;
  @Input() public placeholder = "Select load type";
  public readonly disabled = input(false);
  public readonly showClear = input(false);

  public subscription = new Subscription();
  public loadTypeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildLoadTypeList();
  }

  public onLoadTypeChange(event: { value: string }) {
    this.loadType = event.value;
    this.loadTypeChange.emit(event.value);
  }

  public clearLoadType() {
    this.loadType = null;
    this.loadTypeChange.emit(null);
  }

  public getLoadTypeLabel(value: string): string {
    return this.loadTypeList.find((item) => item.value === value)?.label ?? "";
  }

  private buildLoadTypeList() {
    (Object.keys(loadType) as (keyof typeof loadType)[]).map((key) => {
      this.loadTypeList.push({
        label: loadType[key],
        value: key,
      });
    });
  }
}
